/** .........
 * The name of the bundled audio file which will be played for the incoming user requests for
 * joining  the conference
 *
 * @type {string}
 */
export const INCOMING_USER_KNOCKING_SOUND_FILE = 'join_meeting.mp3';
